"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseInterceptor = void 0;
class ResponseInterceptor {
    constructor(axios) {
        this.axios = axios;
        this.axios = axios;
    }
    rejectResponse(config, message, statusCode) {
        const rejectError = new this.axios.AxiosError(message, statusCode, config);
        return Promise.reject(rejectError);
    }
    register(axiosInst) {
        axiosInst.interceptors.response.use(this.onFulfilled.bind(this), this.onRejected.bind(this));
    }
}
exports.ResponseInterceptor = ResponseInterceptor;
